export default [
  {
    path: '/certificateDetail',
    name: 'CertificateDetail',
    component: () => import('@/views/certificate/certificateDetail.vue'),
    meta: { title: 'certificate_details', hidden: true }
  },
  {
    path: '/certificateAvailable',
    name: 'CertificateAvailable',
    component: () => import('@/views/certificate/certificateAvailable.vue'),
    meta: { title: 'certificate_available', icon: 'certificate_available' }
  }
]
